module.exports = __webpack_public_path__ + "img/4pickup.703ff828.gif";